<template>
  <div  class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Dispositivos Biométricos</ModuleHeader>
      <v-row>
        <v-col>
          <v-select
            placeholder="Tipo SDK"
            v-model="TipoSDK"
            @change="selectSDK()"
            :items="dataSDK"
            label="Tipo SDK"
            item-text="Name"
            item-value="id"
          >
          </v-select>
        </v-col>
      </v-row>
      <uv-data-table
        :config="config"
        :data="biometricDevices"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
  </div>
</template>



<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import ApiBioTime from "../../../clases/ApiBioTime.js";
import axiosCore from "axios";

export default {
  name: "MovimientosCRUD",
  components: {
    uvDataTable,
  },
  props:['membresia_id'],
  data() {
    return {
      TipoSDK:'',
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      showModal: false,
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol:{Field:"",Type:"Asc"},
        buttons: [
        ],
        fields: [
          {
            text: "NOMBRE",
            value: "dev_alias",
          },
          {
            text: "Serial",
            value: "sn",
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
      biometricDevices: [],
      dataSDK:[],
      lastRecord:{},
    };
  },
  computed: {},
  methods: {
    async selectSDK(){
      let api  = await ApiBioTime.getInstance(this.TipoSDK);
      let devices = await api.get("/Devices");
      this.biometricDevices = devices.data;
    },
    async getBiometricDevices() {
      let axiosInstance = axiosCore.create({
        baseURL: "http://192.168.0.23:81/",
        headers: {
          "Content-Type": "application/json",
        },
        /*transformRequest: (data) => {
          return JSON.stringify(data);
        },*/
      });
      const response = await axiosInstance.post("jwt-api-token-auth/", {
        username: "pargolfsolutions",
        password: "pgs9981234567",
      });
      const devices = await axiosInstance.get("iclock/api/terminals/", {
        headers: {
          Authorization: `JWT ${response.data.token}`,
        },
      });
      let devicesList = devices.data.data;
      devicesList.forEach((device)=>{
        device.desc = device.alias+" | Serial -"+device.sn + " | IP:"+device.ip_address;
      })
      this.biometricDevices = devicesList ;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createMovimiento(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addDispositivo") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Dispositivo");
        this.toggleModal(true);
      }
      if (buttonId == "editarMembresia") {
        this.idSelected = idSelected[0];
        const cashier = this.$pgsHelper.getById(
          this.data_membresias,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = cashier;
        this.$refs.modalForm.setTitle("Editar Membresia");
        this.toggleModal(true);
      }
      if (buttonId == "reportMembresia"){
        this.$router.push({ path: "/membresias/movimientos" });
      }
      if (buttonId == "deleteMembresia") {
        this.deleteCliente(idSelected[0]);
      }
    },
    async getMovimientos() {
      this.data_movimentos = [];
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    createMovimiento(data) {
      this.$swal({
        title: "¿Deseas guardar el movimiento?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Movimientos-createMovimiento", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El Movimiento se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.getMovimientos()
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving movimiento",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getTiposSdk(){
      const conf = await this.$store.getters.getFirebaseApp.database.queryBuilder("BIO/Activos");
      let resultConf = conf.val();
      this.dataSDK = this.$pgsHelper.ArrayObjectToArray(resultConf);
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    await this.getTiposSdk();

  },
};
</script>